// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhr_a big_h","Menu__offsetParent":"bhr_b big_bj","Menu__trigger--shadowed":"bhr_c"};